var React = require('react');

function HudlSlash1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 52"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Group-52"},[React.createElement("polygon",{"id":"Fill-1-Copy-4","fill":"#EDF0F2","points":"318.579592 0 0 552 336.420408 552 655 0","key":0}),React.createElement("polygon",{"id":"Fill-1-Copy-5","fill":"#DCE1E6","points":"396.967884 29 95 552 366.032116 552 668 29","key":1})]))]);
}

HudlSlash1.defaultProps = {"width":"668px","height":"552px","viewBox":"0 0 668 552","version":"1.1"};

module.exports = HudlSlash1;

HudlSlash1.default = HudlSlash1;
